<template>
  <div class="blog-widget-container">
    <h2 class="blog-widget-title">{{ title }}</h2>

    <div class="blog-widget is-flex">
      <CardVertical
        v-for="(slug, index) in slugs"
        :key="index"
        :slug="slug"
        class="card"
      />
    </div>
  </div>
</template>

<script>
import CardVertical from './CardVertical'

export default {
  components: { CardVertical },
  props: {
    slugs: {
      type: Array,
      required: true,
    },
    title: {
      type: String,
      default: '',
    },
  },
}
</script>

<style lang="scss" scoped>
.blog-widget-container {
  margin: 50px 0;
}
.blog-widget-title {
  text-align: center;
  color: $ps-gray;
  font-family: $family-regular;
  font-size: 1.5rem;
  line-height: 1.5rem;
  // padding: 50px 0 0;
  margin: 20px 0 20px;
  border-top: 1px solid $ps-border;

  @include tablet {
    font-size: 2.5rem;
    line-height: 2.5rem;
    margin: 20px 0 40px;
  }
}
.blog-widget {
  flex-direction: column;
  @include tablet {
    flex-direction: row;
  }
  max-width: 900px;
  margin: 0 auto;
  width: 80%;
}
.card {
  width: 100%;
  margin: 10px;
  @include tablet {
    width: calc(50% - 20px);
  }
}
</style>
